// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form.registration-check {
  background-color: transparent !important;

  .loading-indicator {
    padding: 40px 0;
    color: var(--ce-grey-70);
    text-align: center;
    font-size: 30px;
    width: 100%;
    grid-column: 1;
    grid-row: 1;
    z-index: 0;
  }

  .cf-turnstile {
    grid-column: 1;
    grid-row: 1;
    z-index: 1;
  }

  .turnstile-container {
    display: grid;
    justify-items: center;
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Authentication/Participant/RegistrationCheck.css"],"names":[],"mappings":"AAAA;EACE,wCAAwC;;EAExC;IACE,eAAe;IACf,wBAAwB;IACxB,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,cAAc;IACd,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,cAAc;IACd,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,mBAAmB;EACrB;AACF","sourcesContent":["form.registration-check {\n  background-color: transparent !important;\n\n  .loading-indicator {\n    padding: 40px 0;\n    color: var(--ce-grey-70);\n    text-align: center;\n    font-size: 30px;\n    width: 100%;\n    grid-column: 1;\n    grid-row: 1;\n    z-index: 0;\n  }\n\n  .cf-turnstile {\n    grid-column: 1;\n    grid-row: 1;\n    z-index: 1;\n  }\n\n  .turnstile-container {\n    display: grid;\n    justify-items: center;\n    align-items: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
